import { Component, OnInit, Input } from '@angular/core';
import { PublicService, IGenericSetting } from '../services/public.service';

@Component({
    selector: 'app-outtage-message',
    templateUrl: './outtage.component.html',
    standalone: false
})
export class OuttageComponent implements OnInit {
  @Input() outageText = '';
  public outtageSetting: IGenericSetting = new IGenericSetting();
  constructor(private publicService: PublicService) { }
  ngOnInit() {
    this.outtageSetting.value = this.outageText;
    this.publicService.getOuttageMessage().subscribe((setting: IGenericSetting) => {
      if (setting) {
        this.outtageSetting = setting;
      }
    });
  }
}
